// import FancyText from "@carefully-coded/react-text-gradient";
import {
  // Alert,
  // AlertTitle,
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import SuggestionChips from "./suggestions";
import { motion } from "framer-motion";
import { getFirstName } from "../utils/common";
import { useAuth } from "../provider/auth_provider";

export default function NewChatGreetings({
  suggestions,
  tool,
  vectorName,
}: {
  suggestions: string[];
  tool: string;
  vectorName: string;
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { userDetails } = useAuth();

  theme.typography.h1 = {
    fontSize: "4rem",
    textWrap: "nowrap",

    "@media (min-width:37.5rem)": {
      fontSize: "4rem",
      textWrap: "nowrap",
    },

    [theme.breakpoints.up("md")]: {
      fontSize: "3.2rem",
      textWrap: "nowrap",
    },
  };
  return (
    <Box
      // height={"100%"}
      display="flex"
      flexDirection="column"
      justifyContent={"center"}
      alignItems="center"
      px={2}
      mt={6}
      sx={{ width: "100", cursor: "default" }}
    >
      <Grid container justifyContent={"center"} alignItems={"flex-start"}>
        <Grid item md={8}>
          {/* <motion.div
            initial={{ y: 100 }}
            transition={{ duration: 0.5 }}
            whileInView={{ y: 0 }}
            style={{ zIndex: -1 }}
          >
            <Typography
              // variant={isSmallScreen ? "h3" : "h1"}
              variant={isSmallScreen ? "h2" : "h1"}
              fontWeight={"700"}
            >
              <LinearGradient gradient={["to left", "#fbd07c ,#f7f779"]}>
              <FancyText
                gradient={{
                  from: "#f44336",
                  to: "#212121",
                  type: "linear",
                }}
                animate
                animateDuration={1500}
              >
                {tool}
              </FancyText>
              </LinearGradient>
            </Typography>
          </motion.div> */}
          <motion.div
            initial={{ y: 100 }}
            transition={{ duration: 0.75 }}
            whileInView={{ y: 0 }}
            style={{ zIndex: -1 }}
          >
            <Typography
              variant={isSmallScreen ? "h4" : "h3"}
              fontWeight={"600"}
              mt={4}
              sx={{ color: "#444746", fontSize: 24 }}
            >
              {/* <LinearGradient gradient={["to left", "#fec32f ,#fec32f"]}> */}
              Hello, {getFirstName(userDetails?.name as string)}!
              {/* </LinearGradient> */}
            </Typography>
          </motion.div>
          <motion.div
            initial={{ y: 100 }}
            transition={{ duration: 1 }}
            whileInView={{ y: 0 }}
            style={{ zIndex: -1, textWrap: "nowrap" }}
          >
            <Typography
              variant={isSmallScreen ? "h6" : "h5"}
              color={grey[500]}
              sx={{ fontSize: 16 }}
            >
              Ask me anything!
            </Typography>
          </motion.div>

          <Box mt={4}>
            <SuggestionChips
              suggestions={suggestions}
              gridSpace={4}
              vectorName={vectorName}
            />
          </Box>
          {/* <Box my={2}>
            <motion.div
              initial={{ y: 100 }}
              transition={{ duration: 1.25 }}
              whileInView={{ y: 0 }}
              style={{ zIndex: -1, textWrap: "nowrap" }}
            >
              <Alert severity="warning">
                <AlertTitle>Warning</AlertTitle>
                Always verify the generated response.
              </Alert>
            </motion.div>
          </Box> */}
        </Grid>
      </Grid>
    </Box>
  );
}
